import _implicitStylesheets from "./pluginSpecs.css";
import _implicitScopedStylesheets from "./pluginSpecs.scoped.css?scoped=true";
import _listingPackageContentsViewer from "listing/packageContentsViewer";
import {freezeTemplate, registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element} = $api;
  return [api_custom_element("listing-package-contents-viewer", _listingPackageContentsViewer, {
    props: {
      "viewerTitle": $cmp.viewerTitle,
      "searchPlaceholder": $cmp.searchPlaceholder,
      "rollupTiles": $cmp.rollupTiles,
      "sections": $cmp.sections,
      "isLoading": $cmp.isLoadingMembers,
      "loadingLabel": $cmp.loadingLabel,
      "emptySearchLabel": $cmp.emptySearchLabel,
      "displayListLabel": $cmp.displayListLabel,
      "displayCardsLabel": $cmp.displayCardsLabel,
      "featureContext": "Specs"
    },
    key: 0
  })];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-435190smt2e";
tmpl.legacyStylesheetToken = "undefined-_pluginSpecs";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
